import React from 'react';
import { Box, Button, CircularProgress, Modal, Typography } from '@mui/material';
import { useGetCmailMessage } from '../../console/cmail/CmailInbox/useGetCmailMessage';
import { CmailThreadedView } from '../../console/cmail/components/CmailDetailsResolver/CmailThreadedView';

interface CmailModalProps {
  open: boolean;
  msgId: string | null;
  onClose: () => void;
  onOpenInCmailbox: () => void;
}

export const CmailModal = ({
  open,
  msgId,
  onClose,
  onOpenInCmailbox,
}: CmailModalProps) => {
  const cmailMessageQuery = useGetCmailMessage(msgId || '');

  return (
    <Modal
      open={open && Boolean(msgId)}
      onClose={onClose}
      aria-labelledby="cmail-modal"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: '90%',
          maxWidth: '1000px',
          maxHeight: '90vh',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          overflow: 'auto',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: 16,
            right: 30,
            zIndex: 1,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={onOpenInCmailbox}
            sx={{ mr: 2 }}
          >
            Open in Concierge
          </Button>
          <Button variant="outlined" onClick={onClose}>
            Close
          </Button>
        </Box>
        <Box sx={{ pt: '2rem' }}>
          {cmailMessageQuery.isLoading && (
            <Box sx={{ textAlign: 'center', p: 4 }}>
              <CircularProgress />
              <Typography sx={{ mt: 2 }}>Loading email message...</Typography>
            </Box>
          )}
          {cmailMessageQuery.isError && (
            <Box
              sx={{
                textAlign: 'center',
                p: 4,
                color: 'error.main',
              }}
            >
              <Typography>
                Failed to load email message. Please try again or open in
                Concierge.
              </Typography>
            </Box>
          )}
          {cmailMessageQuery.data && (
            <CmailThreadedView
              message={cmailMessageQuery.data}
              enrichedMessage={cmailMessageQuery.data}
            />
          )}
          {!cmailMessageQuery.isLoading &&
            !cmailMessageQuery.isError &&
            !cmailMessageQuery.data && (
              <Box sx={{ textAlign: 'center', p: 4 }}>
                <Typography>No email message data available.</Typography>
              </Box>
            )}
        </Box>
      </Box>
    </Modal>
  );
};
